import { HistoricalComparisonSpec } from './HistoricalComparisonSpec';
import { MarkBasedComparisonSpec } from './MarkBasedComparisonSpec';
import { NoComparisonSpec } from './NoComparisonSpec';
import { StaticComparisonSpec } from './StaticComparisonSpec';

export type ComparisonSpecType =
  | HistoricalComparisonSpec
  | NoComparisonSpec
  | MarkBasedComparisonSpec
  | StaticComparisonSpec;

export function isStaticComparison(spec: ComparisonSpecType): spec is StaticComparisonSpec {
  return spec.type === 'STATIC_COMPARISON';
}

export function isMarkBasedComparison(spec: ComparisonSpecType): spec is MarkBasedComparisonSpec {
  return spec.type === 'MARK_BASED_COMPARISON';
}

export const isNoComparison = (spec: ComparisonSpecType): boolean => {
  return spec.type === 'NO_COMPARISON';
};

export function isHistoricalComparisonSpec(spec: ComparisonSpecType): spec is HistoricalComparisonSpec {
  return spec.type === 'HISTORICAL_COMPARISON';
}

export function isHistoricalOrMarkBasedComparison(
  spec: ComparisonSpecType
): spec is HistoricalComparisonSpec | MarkBasedComparisonSpec {
  return isHistoricalComparisonSpec(spec) || isMarkBasedComparison(spec);
}

export const shouldShowComparisonLine = (comparison: ComparisonSpecType | null): boolean => {
  if (comparison === null) {
    return false;
  }
  if (isHistoricalComparisonSpec(comparison)) {
    return comparison.showComparisonLine ?? false;
  }
  if (isMarkBasedComparison(comparison)) {
    return false;
  }
  if (isStaticComparison(comparison)) {
    return true;
  }
  return false;
};
